/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `
{{^products}}
	<div class="w100 flex-center">
		<div class="swym-wishlist-no-item">
			<h2>Love It? Add To My Wishlist</h2>
			<p class="mb-2 text-center">My Wishlist allows you to keep track of all of your favorites and shopping activity whether you're on your computer, phone, or tablet. You won't have to waste time searching all over again for that item you loved on your phone the other day - it's all here in one place!</p>
			<a class="button button--primary" href="/collections/all">Shop All</a>
		</div>
	</div>
	<style>
	.swym-share {display: none !important;}
	</style>
{{/products}}
<div class="swym-wishlist-grid">
	{{#products}}
	<div class="swym-wishlist-item">
		<button type="button" id="swym-remove-productBtn" aria-label="Delete {{dt}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
			<span class="swym-icon">
			</span>
		</button>
		<a href="{{du}}" aria-label="{{dt}}" class="swym-is-anchor">
			<div class="swym-wishlist-image-wrapper mb-1">
				<img alt="" class="swym-wishlist-image" src="{{iu}}">
			</div>
			<div class="swym-is-button">
				<div class="h5 mb-1">
					{{dt}}
				</div>
			</div>
			<div class="swym-product-price swym-text swym-text-1 mb-1">
				<div class="swym-product-final-price swym-value">
					{{cu}}{{pr}}
				</div>
			</div>
		</a>
		<quick-buy-selects class="quick-buy__wrapper product-connections always-show" variant-ids="{{epi}}" line-item-props='{"_sales_channel":"online_store"}' data-target="quickbuyitem-{{empi}}">
			<input type="hidden" name="quantity" value="1">
			<button type="button" data-quick-buy-btn class="button button--secondary button--small w100" data-quick-buy-function data-trigger="quickbuyatc-{{empi}}">
				<span>Add to cart</span>
				<div class="loading-overlay__spinner">
					<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
					</svg>
				</div>
			</button>
			<div class="product-quickbuy__error-message-wrapper hidden" role="alert" hidden="">
				<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
				<circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
				<circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
				<path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
				<path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
				</path></svg>
				<span class="product-quickbuy__error-message"></span>
			</div>
			<div class="loading-overlay product-loading gradient hidden">
				<div class="loading-overlay__spinner">
					<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
					</svg>
				</div>
			</div>
		</quick-buy-selects>
	</div>
	{{/products}}
</div>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

// function onAddToCartClick(e) {
// 	e.preventDefault();
// 	var productId = e.currentTarget.getAttribute("data-product-id");
// 	var variantId = e.currentTarget.getAttribute("data-variant-id");
// 	var du = e.target.getAttribute("data-product-url");
// 	e.target.innerHTML = "Adding..";
// 	window._swat.replayAddToCart({
// 		empi: productId,
// 		du: du
// 	}, variantId, function(c) {
// 		e.target.innerHTML = "Added to Cart";
// 		e.target.setAttribute("data-state-cart", "swym-added");
// 		console.log("Successfully added product to cart.", c);
// 	}, function(e) {
// 		console.log(e);
// 	});
// }

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		console.log(products)
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  console.log("Container not found, Wishlist Page element not found");
		}
	});
}

function attachClickListeners() {
	// var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	// for (var i = 0; i < addToCartButtons.length; i++) {
	// 	addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	// }
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */


// Share Wishlist
function onShareWishlist(event){
	event.preventDefault();
	const shareFromName = document.getElementById("swym-sender-name");
	const shareToEmail = document.getElementById("swym-recepient-email");
	const shareMessage = document.getElementById("swym-share-message");
	let params = {
			toEmailId: shareToEmail.value,
			fromName: shareFromName.value,
			note: shareMessage.value,
			lid: null,
			cprops: {}
	}
	
	_swat.sendListViaEmail(params, (response)=>{
			let receiver = params.toEmailId;
			_swat.ui.uiRef.showSuccessNotification({ message: `Successfully shared wishlist with  ${receiver}` });
			closeShareModal();
		}, (error) => {
			_swat.ui.uiRef.showErrorNotification({ message: error });
	});
}
let shareModalTrigger = null;

function showShareWishlist(){
	let shareModal = document.getElementById('swym-custom-share-container');
	shareModal.classList.remove("swym-hide-container");
	shareModalTrigger = document.activeElement;
	trapFocus(shareModal.querySelector('.swym-modal-content'));
	document.addEventListener('keydown', onShareModalKeydown);
}

function closeShareModal(event){
	let shareModal = document.getElementById('swym-custom-share-container');
	shareModal.classList.add("swym-hide-container");
	document.removeEventListener('keydown', onShareModalKeydown);
	const fromKeyboard = !event || event.detail === 0;
	const returnTo = fromKeyboard && shareModalTrigger && shareModalTrigger !== document.body ? shareModalTrigger : null;
	removeTrapFocus(returnTo);
}

function onShareModalKeydown(event){
	if (event.key === 'Escape') closeShareModal(event);
}

const shareWishlisOptions = document.querySelectorAll('.swym-share__option');
shareWishlisOptions.forEach(option => {
	option.addEventListener('click', (e) => {
		e.preventDefault();
		let onSuccess = (link, lid) => {
			if (option.classList.contains('swym-share__option--link')) {
				_swat.ui.uiRef.showSuccessNotification({ message: `Link copied to clipboard.` });
				navigator.clipboard.writeText(link);
				closeShareModal(e);
			} else {
				let lid = null;
				let fromName = "";
				let shareurl = link;
				let note = "";
				let platform = "facebook";
				let platformShareUrlTemplate = "https://www.facebook.com/sharer.php?u=" + shareurl;
				if (option.classList.contains('swym-share__option--twitter')) {
					platform = "twitter";
					platformShareUrlTemplate = "https://www.twitter.com/sharer.php?u=" + shareurl;
				}
				let onError = function(error) {
					console.log("There was an Error opening the share platform ("+ platform +")", error);
				}
				_swat.shareListSocial(lid, fromName, platformShareUrlTemplate, platform, note, onError);
			}
		}
		let onError = (error) => {
			console.log("Error while generating the link", error)
		}
		_swat.generateSharedListURL(null, onSuccess, onError);
	})
})